/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.badge {
  border-radius: calc(infinity * 1px);
  color: var(--color-white, #fff);
  text-align: center;
  width: 18px;
  height: 18px;
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  --tw-leading: 1.1rem;
  line-height: 1.1rem;
}
.SUCCESS {
  background-color: var(--color-success-dark, #15803d);
}
.WARNING {
  background-color: var(--color-warning-dark, #c2410c);
}
.DANGER {
  background-color: var(--color-danger-dark, #b91c1c);
}
.NEUTRAL {
  background-color: var(--color-emphasis-high, #000);
}
.LIGHT {
  color: var(--color-emphasis-high, #000);
  background-color: var(--color-gray-200, #e5e5e5);
}
.DARK {
  background-color: var(--color-neutral-700, oklch(37.1% 0 none));
}
.BLUE {
  background-color: var(--color-blue-700, oklch(48.8% 0.243 264.376));
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
      --tw-leading: initial;
    }
  }
}
